

import Vue from 'vue'
import App from './App'
import less from 'less'
import router from './router/index'
import { sync } from 'vuex-router-sync'
import store from './store/store'
import FastClick from 'fastclick'
import VueLazyload from 'vue-lazyload'
import { format, NullToEmpty } from './util/util'
import { getToken } from './util/jwtAuth'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import VConsole from 'vconsole';
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {

} else if (process.env.NODE_ENV === 'production') {

}
var options = {
fullscreenEl: false,//关闭全屏按钮
tapToClose: true
}
Vue.use(less)
Vue.use(preview, options)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
sync(store, router)
Vue.config.productionTip = false
FastClick.attach(document.body)
Vue.use(VueLazyload, {
preLoad: 1.3,
error: '',
loading: '',
attempt: 2,
listenEvents: ['scroll', 'mousewheel']
})
Vue.filter('date', function (value, fmt) {
return format(value, fmt)
})
Vue.filter('empty', function (from, to) {
return NullToEmpty(from, to)
})
Vue.filter('price', function (val) {
return Number(val).toFixed(2)
})
Vue.prototype.showConfirm = function (content, cancel, confirm, cancel_text, confirm_text) {
this.$vux.confirm.show({
cancelText: cancel_text,
confirmText: confirm_text,
title: '温馨提示',
content: content,
onCancel() {
if (typeof cancel === 'function') {
cancel()
}
},
onConfirm() {
if (typeof confirm === 'function') {
confirm()
}
}
})
}
Vue.prototype.showAlert = function (content, call) {
this.$vux.alert.show({
title: '温馨提示',
content: content,
onShow() { },
onHide() {
if (typeof call === 'function') {
call()
}
}
})
}
Vue.prototype.showToast = function (content, t) {
let b = 'top'
if (!t) {
t = 2000
b = 'bottom'
}
this.$vux.toast.show({
text: content,
position: b,
type: 'text',
time: t
})
}
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
} else {
document.title = '周大生商城'
}
window.onscroll = null
if (to.path === '/modify') {
next()
} else {
if (to.path === '/login' || to.path === '/') {
next()
} else {
if (getToken()) {
next()
} else {
if (to.fullPath) {
next('/login?redirect=' + to.fullPath)
} else {
next('/')
}
}
}
}
})
/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js